module.exports = __webpack_public_path__ + "img/mes3.8e6fed9f.png";